import { render, staticRenderFns } from "./ChannelSelector.vue?vue&type=template&id=9191524a&scoped=true&lang=html&"
import script from "./ChannelSelector.vue?vue&type=script&lang=js&"
export * from "./ChannelSelector.vue?vue&type=script&lang=js&"
import style0 from "./ChannelSelector.vue?vue&type=style&index=0&id=9191524a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9191524a",
  null
  
)

export default component.exports